import Hero from "../components/Hero";
import AudienceSection from "../components/AudienceSection";
import PracticeAreas from "../components/PracticeAreas";
import Process from "../components/Process";
import AreaLinks from "../components/AreaLinks";
import WhyJuris from "../components/WhyJuris";
import ContactSection from "../components/ContactSection";

export const LandingPage = () => (
  <main>
    <Hero />
    <AudienceSection />
    <PracticeAreas />
    <Process />
    <AreaLinks />
    <WhyJuris />
    <ContactSection />
  </main>
);

export default LandingPage;
